import React from 'react';
import './Pagination.css';

function Pagination({currentPage, totalPages, onPageChange}) {
  if (totalPages <= 1) return null;

  const getVisiblePages = () => {
    const pages = [];

    pages.push(1);

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) {
      pages.push('ellipsis-start');
    }

    for (let i = start; i <= end; i += 1) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      pages.push('ellipsis-end');
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  const pages = getVisiblePages();

  return (
    <div className="pagination">
      <button
        className="pagination-button"
        type="button"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        ←
      </button>

      <div className="pagination-pages">
        {pages.map((page) => {
          if (typeof page === 'string') {
            return (
              <span key={page} className="pagination-ellipsis">
                …
              </span>
            );
          }

          return (
            <button
              key={page}
              className={`pagination-page ${page === currentPage ? 'pagination-page_active' : ''}`}
              type="button"
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          );
        })}
      </div>

      <button
        className="pagination-button"
        type="button"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        →
      </button>
    </div>
  );
}

export default Pagination;
